import { call } from 'redux-saga/effects';
import fetchData from './apiRequest';

export function* updateProfileRequest(profileId, data) {
  return yield call(fetchData, `profiles/${profileId}`, {
    method: 'PATCH',
    body: data
  });
}
